import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import { red } from "@material-ui/core/colors"
import {
  IconButton,
  Card,
  CardContent,
  List,
  Typography,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@material-ui/core"
import HistoryListItem from "./historyItems/HistoryListItem"
import Skeleton from "@material-ui/lab/Skeleton"

import SyncIcon from "@material-ui/icons/Sync"

const useStyles = makeStyles((theme) => ({
  activityList: {
    height: "60vh",
    overflowY: "scroll",
  },
  card: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    spacing: 3,
    marginBottom: 50,
    position: "relative",
  },
  title: {
    fontSize: 20,
    textTransform: "uppercase",
  },
  detail: {
    fontSize: 12,
    fontStyle: "italic",
  },
  error: {
    color: red[500],
  },
  refreshButton: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  timestamp: {
    fontWeight: "bold",
  },
}))

const getSkeleton = () => {
  let placeholder = []
  for (let i = 0; i < 20; i++) {
    placeholder.push(
      <ListItem key={i} style={{ marginBottom: 20 }}>
        <ListItemIcon>
          <Skeleton variant="circle" width={24} height={24} />
        </ListItemIcon>
        <ListItemText>
          <Skeleton animation="wave" width="80%" />
          <Skeleton animation="wave" width="80%" />
          <Skeleton animation="wave" width="40%" />
        </ListItemText>
      </ListItem>
    )
  }
  return placeholder
}

const ActivityFeedCard = ({ error, loading, activities, refreshHistory, title }) => {
  const classes = useStyles()

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent>
        <IconButton
          className={classes.refreshButton}
          color="primary"
          aria-label="refresh history"
          variant="contained"
          disableElevation
          disabled={loading}
          onClick={refreshHistory}
        >
          <SyncIcon />
        </IconButton>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          {title}
        </Typography>

        {error && <p className={classes.error}>{error}</p>}
        <List
          className={classes.activityList}
          component="nav"
          aria-label="exceptions"
        >
          {activities &&
            activities.map((item) => <HistoryListItem key={item.id} item={item} />)}
          {loading && getSkeleton()}
        </List>
      </CardContent>
    </Card>
  )
}

ActivityFeedCard.propTypes = {
  error: PropTypes.string,
  loading: PropTypes.bool,
  activities: PropTypes.array,
  refreshHistory: PropTypes.func,
  title: PropTypes.string,
  onActionError: PropTypes.func,
  onACtionSucess: PropTypes.func,
}

export default ActivityFeedCard
